var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_6",
    "data-name": "Clip 6",
    d: "M0,0H5.774V6.707H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Game",
    transform: "translate(-2425 -7506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20644",
    "data-name": "Group 20644"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6398",
    "data-name": "Rectangle 6398",
    width: 18,
    height: 18,
    transform: "translate(2425 7506)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(2426 7508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M1.9,3.788a1.917,1.917,0,0,1-.956-.245,1.828,1.828,0,0,1-.69-.677A1.873,1.873,0,0,1,0,1.891,1.884,1.884,0,0,1,.256.917,1.816,1.816,0,0,1,.946.243,1.945,1.945,0,0,1,1.9,0a1.923,1.923,0,0,1,.953.243,1.8,1.8,0,0,1,.686.674,1.908,1.908,0,0,1,.252.975,1.9,1.9,0,0,1-.252.974,1.817,1.817,0,0,1-.688.677A1.9,1.9,0,0,1,1.9,3.788ZM1.9,1.357a.537.537,0,1,0,.537.537A.538.538,0,0,0,1.9,1.357Z",
    transform: "translate(12.131 7.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M3.494,6.669H0V.628A.629.629,0,0,1,.628,0H3.4A2.605,2.605,0,0,1,5,.443a1.526,1.526,0,0,1,.584,1.29,1.578,1.578,0,0,1-.306.984,1.46,1.46,0,0,1-.815.532,1.6,1.6,0,0,1,.937.579,1.63,1.63,0,0,1,.334,1.013,1.657,1.657,0,0,1-.579,1.352A2.571,2.571,0,0,1,3.494,6.669ZM2.091,4.05v.942h.951a.67.67,0,0,0,.419-.108A.425.425,0,0,0,3.6,4.531c0-.319-.187-.481-.555-.481Zm0-2.393V2.6H2.9a.652.652,0,0,0,.419-.113.428.428,0,0,0,.136-.349.455.455,0,0,0-.136-.363A.631.631,0,0,0,2.9,1.658Z",
    transform: "translate(0.019 0.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_6-2",
    "data-name": "Clip 6",
    d: "M0,0H5.774V6.707H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7-2",
    "data-name": "Group 7",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M3.513,6.706H0V.647A.648.648,0,0,1,.647,0H3.419A2.623,2.623,0,0,1,5.032.447a1.544,1.544,0,0,1,.591,1.305,1.6,1.6,0,0,1-.31,1,1.465,1.465,0,0,1-.756.52,1.6,1.6,0,0,1,.879.569A1.648,1.648,0,0,1,5.774,4.86a1.675,1.675,0,0,1-.586,1.366A2.589,2.589,0,0,1,3.513,6.706ZM.647.038A.61.61,0,0,0,.038.647V6.669H3.513A2.553,2.553,0,0,0,5.164,6.2,1.638,1.638,0,0,0,5.736,4.86a1.61,1.61,0,0,0-.331-1,1.58,1.58,0,0,0-.926-.573L4.4,3.27l.074-.019a1.438,1.438,0,0,0,.8-.525,1.561,1.561,0,0,0,.3-.973A1.508,1.508,0,0,0,5.009.477,2.587,2.587,0,0,0,3.419.038ZM3.061,5.03h-.97V4.05h.97c.381,0,.575.168.575.5a.443.443,0,0,1-.144.368A.692.692,0,0,1,3.061,5.03Zm-.932-.942v.9h.932a.655.655,0,0,0,.407-.1A.408.408,0,0,0,3.6,4.55c0-.311-.176-.462-.537-.462Zm.791-1.45H2.091v-.98H2.92a.651.651,0,0,1,.431.122.474.474,0,0,1,.143.377.446.446,0,0,1-.143.363A.669.669,0,0,1,2.92,2.638ZM2.129,1.7v.9H2.92a.636.636,0,0,0,.407-.109.411.411,0,0,0,.13-.334.439.439,0,0,0-.13-.349A.616.616,0,0,0,2.92,1.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M1.587,6.353a3.64,3.64,0,0,0,1.8.429A3.3,3.3,0,0,0,5.322,6.25a4.06,4.06,0,0,0,1.1-1.118.617.617,0,0,0,.1-.336V3.51a.628.628,0,0,0-.628-.628H3.746a.628.628,0,0,0-.628.628v.851H4.785a1.4,1.4,0,0,1-1.168.584,1.493,1.493,0,0,1-1.13-.386,1.639,1.639,0,0,1-.367-1.168,1.606,1.606,0,0,1,.33-1.069,1.153,1.153,0,0,1,.932-.391,1.257,1.257,0,0,1,.546.108.81.81,0,0,1,.349.306H5.633a.629.629,0,0,0,.551-.93A2.465,2.465,0,0,0,5.505.631,3.413,3.413,0,0,0,3.372,0a3.594,3.594,0,0,0-1.79.429A2.921,2.921,0,0,0,.41,1.629,3.7,3.7,0,0,0,0,3.391,3.7,3.7,0,0,0,.41,5.152a2.911,2.911,0,0,0,1.177,1.2",
    transform: "translate(9.306 0.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M3.41,6.819A3.673,3.673,0,0,1,1.6,6.389,2.942,2.942,0,0,1,.412,5.18,3.734,3.734,0,0,1,0,3.41,3.738,3.738,0,0,1,.412,1.64,2.955,2.955,0,0,1,1.592.431,3.633,3.633,0,0,1,3.391,0,3.445,3.445,0,0,1,5.536.635a2.5,2.5,0,0,1,.683.79.648.648,0,0,1-.567.958H4.285l-.006-.009a.794.794,0,0,0-.341-.3A1.24,1.24,0,0,0,3.4,1.969a1.14,1.14,0,0,0-.918.384A1.6,1.6,0,0,0,2.157,3.41a1.628,1.628,0,0,0,.362,1.155,1.48,1.48,0,0,0,1.116.381A1.379,1.379,0,0,0,4.765,4.4H3.118v-.87a.648.648,0,0,1,.647-.647H5.909a.648.648,0,0,1,.647.647V4.815a.632.632,0,0,1-.1.346,4.091,4.091,0,0,1-1.1,1.123A3.328,3.328,0,0,1,3.41,6.819ZM3.391.038a3.6,3.6,0,0,0-1.78.426A2.918,2.918,0,0,0,.445,1.657,3.7,3.7,0,0,0,.038,3.41,3.7,3.7,0,0,0,.445,5.162a2.9,2.9,0,0,0,1.17,1.193,3.643,3.643,0,0,0,1.795.426,3.3,3.3,0,0,0,1.92-.528A4.067,4.067,0,0,0,6.423,5.14a.593.593,0,0,0,.095-.326V3.529a.61.61,0,0,0-.609-.609H3.765a.61.61,0,0,0-.609.609v.832H4.842l-.023.03a1.419,1.419,0,0,1-1.183.591,1.515,1.515,0,0,1-1.144-.392A1.662,1.662,0,0,1,2.119,3.41a1.633,1.633,0,0,1,.334-1.081,1.175,1.175,0,0,1,.947-.4,1.282,1.282,0,0,1,.554.11.838.838,0,0,1,.351.3H5.652a.61.61,0,0,0,.534-.9A2.463,2.463,0,0,0,5.513.665,3.41,3.41,0,0,0,3.391.038Z",
    transform: "translate(9.287 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M3.792.628V2.233H1.944V0H.628A.628.628,0,0,0,0,.628V6.2H1.944V3.783H3.792V6.2H5.736V0H4.42a.628.628,0,0,0-.628.628",
    transform: "translate(0.019 7.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M1.982,6.239H0V.647A.648.648,0,0,1,.647,0H1.982V2.233h1.81V.647A.648.648,0,0,1,4.439,0H5.774V6.238H3.792V3.821H1.982V6.238ZM1.944,3.783H3.83V6.2H5.736V.038h-1.3A.61.61,0,0,0,3.83.647V2.271H1.944V.038H.647A.61.61,0,0,0,.038.647V6.2H1.944V3.784Z",
    transform: "translate(0 7.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M.478,9.2H2.091V0H.628C.281,0,0,.194,0,.433V8.867c0,.182.214.329.478.329",
    transform: "translate(6.462 2.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M2.129,9.234H.5c-.274,0-.5-.156-.5-.348V.452C0,.2.29,0,.647,0H2.129V9.234ZM.647.038C.311.038.038.224.038.452V8.886c0,.171.206.31.459.31H2.091V.038Z",
    transform: "translate(6.443 2.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    "data-name": "Fill 24",
    d: "M5.714,4.578H2.091V0H.628A.628.628,0,0,0,0,.628V6.669H6.669V5.533a.955.955,0,0,0-.955-.955",
    transform: "translate(9.306 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_26",
    "data-name": "Fill 26",
    d: "M6.707,6.706H0V.647A.648.648,0,0,1,.647,0H2.129V4.578h3.6a.975.975,0,0,1,.974.974V6.706ZM.647.038A.61.61,0,0,0,.038.647V6.669H6.669V5.552a.937.937,0,0,0-.936-.936H2.091V.038Z",
    transform: "translate(9.287 6.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_28",
    "data-name": "Fill 28",
    d: "M1.3.145a.29.29,0,0,0-.5,0L.039,1.452a.29.29,0,0,0,.252.436H1.8a.29.29,0,0,0,.252-.436Z",
    transform: "translate(6.499 0.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_30",
    "data-name": "Fill 30",
    d: "M1.819,1.926H.31a.309.309,0,0,1-.268-.464L.8.155a.309.309,0,0,1,.536,0l.755,1.307a.309.309,0,0,1-.268.464ZM1.065.038A.268.268,0,0,0,.83.174L.075,1.481a.271.271,0,0,0,.235.407H1.819a.271.271,0,0,0,.235-.407L1.3.174A.268.268,0,0,0,1.065.038Z",
    transform: "translate(6.479 0.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_32",
    "data-name": "Fill 32",
    d: "M1.8,0H.291A.29.29,0,0,0,.039.436L.794,1.743a.29.29,0,0,0,.5,0L2.052.436A.29.29,0,0,0,1.8,0",
    transform: "translate(6.499 11.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_34",
    "data-name": "Fill 34",
    d: "M1.065,1.926A.306.306,0,0,1,.8,1.771L.042.464A.309.309,0,0,1,.31,0H1.819a.309.309,0,0,1,.268.464L1.333,1.771A.306.306,0,0,1,1.065,1.926ZM.31.038A.268.268,0,0,0,.075.173a.269.269,0,0,0,0,.272L.83,1.752a.271.271,0,0,0,.47,0L2.054.445a.269.269,0,0,0,0-.272A.268.268,0,0,0,1.819.038Z",
    transform: "translate(6.48 11.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_38",
    "data-name": "Fill 38",
    d: "M1.921,3.826a1.942,1.942,0,0,1-.965-.247,1.855,1.855,0,0,1-.7-.684A1.905,1.905,0,0,1,0,1.91,1.907,1.907,0,0,1,.258.926a1.839,1.839,0,0,1,.7-.682A1.961,1.961,0,0,1,1.921,0a1.946,1.946,0,0,1,.963.245,1.825,1.825,0,0,1,.692.682,1.923,1.923,0,0,1,.255.984,1.921,1.921,0,0,1-.255.984,1.839,1.839,0,0,1-.695.684A1.931,1.931,0,0,1,1.921,3.826Zm0-3.788a1.92,1.92,0,0,0-.947.24A1.8,1.8,0,0,0,.29.946a1.869,1.869,0,0,0-.253.965,1.87,1.87,0,0,0,.253.965,1.822,1.822,0,0,0,.683.67,1.9,1.9,0,0,0,.947.242,1.893,1.893,0,0,0,.942-.242,1.8,1.8,0,0,0,.681-.67,1.885,1.885,0,0,0,.25-.965,1.884,1.884,0,0,0-.25-.965A1.786,1.786,0,0,0,2.865.278,1.907,1.907,0,0,0,1.921.038Z",
    transform: "translate(12.112 7.339)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGame);
export default __webpack_public_path__ + "static/media/menu-game.7401f63fc6e84925a73d389b4193ed0e.svg";
export { ForwardRef as ReactComponent };